import tree from "../../state";
import * as playerActions from "../../actions/playerActions";
import * as actions from "../../actions/actions";
import PlayerPaths from "../../constants/paths/playerPaths";

export default class PersistenceManagerDefault {

	async init(params) {
		console.log("Initialize persistence manager default", params);
		let activities = params.activities;
		tree.set(PlayerPaths.ROOT_ACTIVITY_ID, activities[0].id); //eslint-disable-line
		await actions.setActivities(tree, activities); //eslint-disable-line
	}

	async save(params) {
		// console.log("Save!");
	}

	async saveAndExit() {
		// console.log("Save and exit!");

		let activity = tree.get(PlayerPaths.ACTIVITY);
		return {
			activity
		};
	}

	async saveResponse() {
		// console.log("Save response!");
	}

	restoreActivityResponsesAndState(activity) {
		// console.log("Restore activity responses and state!");
		return activity;
	}

	async setCompletionState(completionState) {
		// console.log("Set completion state to " + completionState);
	}

	async trackHistory(historyItem) {
		// console.log("Track history item", historyItem);
	}

	async loadActivity(activityId, initialItemId) {
		return await playerActions.loadPublishedActivity(activityId, initialItemId);
	}

	async uploadMediaFile(fileData, fileName, targetType, identityId) {
		return Promise.resolve({ url: "" });
	}
}